import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'components/Table';
import TableRow from 'components/TableRow';
import TableCell from 'components/TableCell';
import ListHeader from 'components/ListHeader';
import MainContainer from 'components/MainContainer';
import LoadingOverlay from 'components/LoadingOverlay';
import { getUsers } from 'api/users';
import { useQuery } from '@tanstack/react-query';

export default function Utenti() {

    
    const { data, isLoading } = useQuery({
        queryKey: ["utenti"],
        queryFn: () => getUsers(),
    });

    return (
        <>

            <LoadingOverlay isLoading={isLoading} />

            <MainContainer>
                <div className='pt-10 pb-5'>
                    <ListHeader
                        title="Utenti"
                        backLink="/impostazioni"
                        create={{
                            component: Link,
                            label: 'Aggiungi',
                            to: `/impostazioni/utenti/crea`
                        }}
                    />
                </div>

                <div>
                    <Table>
                        {data?.map((item) => {
                            return (
                                <TableRow key={item.code} component={Link} to={`/impostazioni/utenti/${item._id}`}>
                                    <TableCell className="font-medium flex-1">
                                        {item?.name}
                                    </TableCell>
                                    <TableCell className="text-right">
                                        {item?.emails.map(e => e.address).join(", ")}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </Table>
                </div>
            </MainContainer>
        </>
    )
}
